import React from 'react';

const sections = [
  {
    title: 'Article 1 : Les mentions légales',
    paragraphs: [
      "3D LOCATION ET PROJETS, SASU inscrite au RCS du Havre sous le numéro 939 728 432 (anciennement D.LOC, au nom de Monsieur Damien JEANNE, immatriculée depuis le 20/08/2018 sous le numéro 841 607 302 R.C.S Le Havre).",
      "L'édition et la direction de la publication du site 3dloc.fr sont assurées par ses représentants, joignables aux coordonnées ci-dessous.",
      'Président : Damien JEANNE',
      'Adresse de la société : Rue Saint-Nicolas – 76930 Cauville-sur-Mer',
      'Adresse du siège social : Route de Montivilliers – 76930 Cauville-sur-Mer',
      'Téléphone : 06 23 89 32 98',
      'E-mail : contact@3dloc.fr',
      "L'hébergeur du site 3dloc.fr est la société OVH, dont le siège social est situé au 2 rue Kellermann – 59100 Roubaix – France (https://www.ovh.fr).",
    ],
  },
  {
    title: 'Article 2 : Accès au site',
    paragraphs: [
      "Le site 3dloc.fr permet à l'Utilisateur un accès gratuit à la consultation des prestations et produits que proposent l'entreprise 3D LOCATION ET PROJETS et sa filiale BARNUM ÉVÉNEMENT LOISIR. Le contenu des prestations de services et les tarifs sont donnés à titre indicatif.",
      "Le site propose également des formulaires de mise en relation et de réservation ayant pour but de recueillir les informations nécessaires afin de répondre aux demandes des utilisateurs et d'établir devis et contrats.",
      "Le site est accessible gratuitement en tout lieu à tout Utilisateur ayant un accès à Internet. Tous les frais supportés par l'Utilisateur pour accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.",
      "En acceptant de compléter les formulaires d'inscription, de réservation ou de contact, l'Utilisateur s'engage à fournir des informations sincères et exactes concernant son état civil et ses coordonnées, notamment son adresse e-mail.",
      "Tout événement dû à un cas de force majeure ayant pour conséquence un dysfonctionnement du site ou du serveur, et sous réserve de toute interruption ou modification en cas de maintenance, n'engage pas la responsabilité de l'entreprise 3D LOCATION ET PROJETS. L'Utilisateur accepte ainsi de ne pas tenir rigueur à l'éditeur de toute interruption ou suspension de service, même sans préavis.",
    ],
  },
  {
    title: 'Article 3 : Collecte des données',
    paragraphs: [
      "Le site assure à l'Utilisateur une collecte et un traitement d'informations personnelles dans le respect de la vie privée, conformément à la loi n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés.",
      "En vertu de cette loi, l'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition sur ses données personnelles. L'Utilisateur exerce ce droit par mail à l'adresse contact@3dloc.fr.",
    ],
  },
  {
    title: 'Article 4 : Propriété intellectuelle',
    paragraphs: [
      "Les marques, logos, signes ainsi que tous les contenus du site (textes, images, son…) font l'objet d'une protection par le Code de la propriété intellectuelle et plus particulièrement par le droit d'auteur.",
      "Toute représentation et/ou reproduction et/ou exploitation partielle ou totale de ces contenus, de quelque nature que ce soit, est totalement prohibée. L'Utilisateur doit solliciter l'autorisation préalable du site pour toute reproduction, publication ou copie des différents contenus.",
      "Il s'engage à une utilisation des contenus du site dans un cadre strictement privé ; toute utilisation à des fins commerciales et publicitaires est strictement interdite.",
      "Toute représentation totale ou partielle de ce site, par quelque procédé que ce soit, sans l'autorisation expresse de l'exploitant, constituerait une contrefaçon sanctionnée par l'article L.335-2 et suivants du Code de la propriété intellectuelle. Conformément à l'article L.122-5, l'Utilisateur qui reproduit, copie ou publie le contenu protégé doit citer l'auteur et sa source.",
    ],
  },
  {
    title: 'Article 5 : Responsabilité',
    paragraphs: [
      "Les sources des informations diffusées sur le site 3dloc.fr sont réputées fiables, mais le site ne garantit pas qu'il soit exempt de défauts, d'erreurs ou d'omissions. Les informations communiquées sont présentées à titre indicatif et général, sans valeur contractuelle.",
      "L'entreprise 3D LOCATION ET PROJETS se réserve le droit de modifier et corriger le contenu du site à tout moment et sans préavis. Malgré des mises à jour régulières, le site ne peut être tenu responsable de la modification des dispositions administratives et juridiques survenant après la publication.",
      "Le site ne peut être tenu pour responsable d'éventuels virus qui pourraient infecter l'ordinateur ou tout matériel informatique de l'internaute à la suite d'une utilisation, d'un accès ou d'un téléchargement provenant de ce site. La responsabilité du site ne peut être engagée en cas de force majeure ou du fait imprévisible et insurmontable d'un tiers.",
    ],
  },
  {
    title: 'Article 6 : Liens hypertextes',
    paragraphs: [
      "Des liens hypertextes peuvent être présents sur le site. L'Utilisateur est informé qu'en cliquant sur ces liens, il sortira du site 3dloc.fr. Ce dernier n'a pas de contrôle sur les pages web vers lesquelles aboutissent ces liens et ne saurait, en aucun cas, être responsable de leur contenu.",
    ],
  },
  {
    title: 'Article 7 : Cookies',
    paragraphs: [
      "L'Utilisateur est informé que, lors de ses visites sur le site, un cookie peut s'installer automatiquement sur son logiciel de navigation. Les cookies sont de petits fichiers stockés temporairement sur le disque dur de l'ordinateur de l'Utilisateur et nécessaires à l'utilisation du site. Ils ne contiennent pas d'information personnelle et ne peuvent pas être utilisés pour identifier quelqu'un.",
      "Un cookie contient un identifiant unique, généré aléatoirement et donc anonyme. Certains cookies expirent à la fin de la visite, d'autres restent. L'information contenue dans les cookies est utilisée pour améliorer le site 3dloc.fr.",
      "L'Utilisateur doit donner son consentement quant à l'utilisation de certains cookies. À défaut d'acceptation, certaines fonctionnalités ou pages risquent de lui être refusées. L'Utilisateur peut désactiver ces cookies via les paramètres de son logiciel de navigation.",
    ],
  },
  {
    title: 'Article 8 : Droit applicable et juridiction compétente',
    paragraphs: [
      "La législation française s'applique au présent contrat. En cas d'absence de résolution amiable d'un litige né entre les parties, les tribunaux français seront seuls compétents pour en juger.",
      "Pour toute question relative à l'application des présentes CGU, vous pouvez joindre l'éditeur aux coordonnées inscrites à l'Article 1.",
    ],
  },
];

export default function MentionsLegalesPage() {
  return (
    <div data-testid="mentions-legales-page" className="bg-slate-50">
      <section className="bg-slate-900 text-white py-14 sm:py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 data-testid="mentions-legales-title" className="text-4xl sm:text-5xl font-black mb-4">Mentions légales</h1>
          <p className="text-slate-300 text-base max-w-3xl leading-relaxed">
            Les présentes conditions générales d'utilisation (« CGU ») ont pour objet l'encadrement juridique des
            modalités de mise à disposition du site 3dloc.fr et des services par l'entreprise 3D LOCATION ET PROJETS,
            et de définir les conditions d'accès et d'utilisation des services par l'Utilisateur.
          </p>
        </div>
      </section>

      <section className="py-12 sm:py-16 px-4">
        <div className="max-w-4xl mx-auto space-y-6">
          <div className="bg-white border border-slate-100 rounded-xl p-6 sm:p-8 text-sm sm:text-base text-slate-600 leading-relaxed space-y-4">
            <p>Les présentes CGU sont accessibles sur le site à la rubrique « CGU ».</p>
            <p>
              Toute inscription ou utilisation du site implique l'acceptation sans réserve ni restriction des présentes
              CGU par l'Utilisateur. En cas de non-acceptation des CGU, l'Utilisateur se doit de renoncer à l'accès des
              services proposés par le site. L'entreprise 3D LOCATION ET PROJETS se réserve le droit de modifier
              unilatéralement et à tout moment le contenu des présentes CGU.
            </p>
          </div>

          {sections.map((section, index) => (
            <article key={section.title} data-testid={`mentions-legales-section-${index}`} className="bg-white border border-slate-100 rounded-xl p-6 sm:p-8">
              <h2 className="text-base md:text-lg font-bold text-slate-800 mb-4">{section.title}</h2>
              <div className="space-y-3 text-sm sm:text-base text-slate-600 leading-relaxed">
                {section.paragraphs.map((text, i) => <p key={i}>{text}</p>)}
              </div>
            </article>
          ))}

          <article className="bg-white border border-slate-100 rounded-xl p-6 sm:p-8">
            <h2 className="text-base md:text-lg font-bold text-slate-800 mb-4">Nos partenaires</h2>
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
              Retrouvez 3D LOCATION ET PROJETS chez nos partenaires : Events DansLaVille, Mairie.com, MariagePresta,
              Mariages.net et Le Bon Coin.
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}
